<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="Transaction history" name="first"></el-tab-pane>
			<el-tab-pane label="New transaction" name="second"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>Search transaction by ID or remark</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-30">
					<md-field>
						<label>Transaction Tag</label>
						<md-select placeholder="Transaction Tag (All)" v-model="search.tag">
							<md-option value="">All</md-option>
							<md-option v-for="tag in tagList" :value="tag.id">{{tag.name}}</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-size-30">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">Search
					</md-button>
				</div>
			</div>
			<md-table v-if="transactionList.length > 0">
				<md-table-row>
					<md-table-head>N.o</md-table-head>
					<md-table-head>TX ID</md-table-head>
					<md-table-head>Type</md-table-head>
					<md-table-head>Tag</md-table-head>
					<md-table-head>Amount</md-table-head>
					<md-table-head>Remark</md-table-head>
					<md-table-head>Date</md-table-head>
				</md-table-row>

				<md-table-row v-for="(transaction, index) in transactionList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>{{ transaction.hash_id }}</md-table-cell>
					<md-table-cell>
						<span class="active" v-if="transaction.type == 'd'">Deposit</span>
						<span class="late" v-if="transaction.type == 'w'">Withdraw</span>
					</md-table-cell>
					<md-table-cell>{{ transaction.name }}</md-table-cell>
					<md-table-cell>{{ config.moneylify(transaction.amount) }}</md-table-cell>
					<md-table-cell>{{ transaction.note }}</md-table-cell>
					<md-table-cell>{{ config.datelify(transaction.created_date) }}</md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell><b>Total Deposit: </b></md-table-cell>
					<md-table-cell><b>{{ config.moneylify(total_deposit) }}</b></md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell><b>Total Withdraw: </b></md-table-cell>
					<md-table-cell><b>{{ config.moneylify(total_withdraw) }}</b></md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell><b>Total Balance: </b></md-table-cell>
					<md-table-cell><b>{{ config.moneylify(total_transaction) }}</b></md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="transactionList.length == 0">No transactions.</h4>
			<div class="places-buttons text-center" v-if="loadMore" >
				<md-button class="md-primary" @click="searchHandler(true)">Load More</md-button>
			</div>
		</div>



		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>Transaction</h3>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Transaction Type</label>
								<md-select placeholder="Transaction Type" v-model="transaction.type"
									@md-selected="checkValidation()">
									<md-option value="d">Deposit</md-option>
									<md-option value="w">Withdraw</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Transaction Tag</label>
								<md-select placeholder="Transaction Tag" v-model="transaction.tag"
									@md-selected="checkValidation()">
									<md-option v-for="tag in tagList" :value="tag.id">{{tag.name}}</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Transaction Amount</label>
								<md-input type="number" v-model="transaction.amount" @keyup="checkValidation()"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Remark (Optional)</label>
								<md-input type="text" v-model="transaction.remark" @keyup="checkValidation()"></md-input>
							</md-field>
						</div>


					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>Summary</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">Transaction Type</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>
									<span class="active" v-if="transaction.type == 'd'">Deposit</span>
									<span class="late" v-if="transaction.type == 'w'">Withdraw</span>
									<span v-if="transaction.type == ''">N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Transaction Amount</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span
										v-if="String(transaction.amount).length > 0">{{config.moneylify(transaction.amount)}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Transaction Remark</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(transaction.amount).length > 0">{{transaction.remark}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button :class="{'md-raised': true, 'md-primary': transaction.valid}" @click="post()">Create
					</md-button>
				</div>

			</div>
		</div>

		<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបក្រុមហ៊ុននេះពិតមែនទេ ?"
			md-content="ព័ត៌មានក្រុមហ៊ុននឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.searchHandler();
			this.getSettings();
		},
		data() {
			return {
				tabName: "first",
				loaded: false,
				transaction: {
					valid: false,
					type: "",
					tag: "",
					amount: "",
					remark: ""
				},
				search: {
					text: "",
					tag: "",
				},
				loadMoren: false,
				tagList: [],
				transactionList: []
			}
		},
		computed: {
			total_deposit() {
				let total = 0;
				for(let i = 0; i< this.transactionList.length; i++) {
					if(this.transactionList[i].type == 'd') {
						total = total + this.transactionList[i].amount;
					}
				}
				return total;
			},
			total_withdraw() {
				let total = 0;
				for(let i = 0; i< this.transactionList.length; i++) {
					if(this.transactionList[i].type == 'w') {
						total = total + this.transactionList[i].amount;
					}
				}
				return total;
			},
			total_transaction() {
				return this.total_deposit - this.total_withdraw;
			}
		},
		methods: {
			getSettings() {
				this.$http.get(this.config.api + "/admin/setting/data/get_all").then(data => {
					this.tagList = data.body.data.tag
				})
			},
			// getTransaction() {
			// 	this.$http.get(this.config.api + "/admin/transaction/get/list/0").then(data => {
			// 		this.transactionList = data.body.data
			// 		this.loaded = true;
			// 	})
			// },
			checkValidation() {
				if (String(this.transaction.type).length > 0 && String(this.transaction.amount).length > 0 && String(this.transaction.tag).length > 0) {
					this.transaction.valid = true
				} else {
					this.transaction.valid = false
				}
			},
			// showDeleteAction(id) {
			// 	this.deleteSelected = id
			// 	this.deleteDialogActive = true
			// },
			post() {
				this.$http.post(this.config.api + "/admin/transaction/post", {
					amount: this.transaction.amount,
					remark: this.transaction.remark,
					type: this.transaction.type,
					tag: this.transaction.tag
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "Transaction was created successfully.",
							icon: 'done',
							type: 'success'
						})
						this.tabName = 'first'
						this.searchHandler();

					}
				})
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/transaction/search", {
					text: this.search.text,
					tag: this.search.tag,
					offset: more ? this.transactionList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					this.transactionList = more ? this.transactionList.concat(data.body.data) : data.body.data;
					if (data.body.data.length == 50) this.loadMore = true
					else this.loadMore = false
				})
			},
			// onCancel() {
			// 	this.deleteSelected = ""
			// 	this.deleteDialogActive = false
			// }
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Transactions/View.vue